export default "__VITE_ASSET__BA8g9FYD__"